import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '@/_metronic/helpers'
import {
  RepartitionData,
  EvolutionData
} from './_models'

const BASE_URL = '/p2c/reports/earnings'

interface IParams {
  from: Date;
  to: Date;
  userId?: ID;
  timezone: string;
}

// eslint-disable-next-line
const formatParams = (params?: Record<string, any>): Record<string, any> => {
  if (!params) return {};

  const formatted = Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');

        return [key, `${year}-${month}-${day}`];
      }
      return [key, value];
    })
  );

  return formatted;
};


/**
 * getRepartition.
 *
 * @returns {Promise<Array<RepartitionData>>}
 */
const getRepartition = async (params: IParams): Promise<Array<RepartitionData>> => {
  return axios
    .get(`${BASE_URL}/repartition`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<RepartitionData>>>) => d.data)
    .then((d: Response<Array<RepartitionData>>) => d.data || [])
}

/**
 * getEvolution.
 *
 * @returns {Promise<Array<EvolutionData>>}
 */
const getEvolution = async (params: IParams & { pad: string }): Promise<Array<EvolutionData>> => {
  return axios
    .get(`${BASE_URL}/evolution`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<EvolutionData>>>) => d.data)
    .then((d: Response<Array<EvolutionData>>) => d.data || [])
}

export {
  getRepartition,
  getEvolution
}
